<template>
    <div class="mb-10 flex flex-col items-center px-5">
        <h1 class="mb-5 text-xl font-bold">
            {{ $t("onboarding.brand.title") }}
        </h1>

        <div class="space-y-10">
            <!-- <div class="grid w-full max-w-sm items-center gap-1.5">
                <Label for="name">{{ $t("appearances.create.name") }}</Label>
                <Input
                    v-model="name"
                    id="name"
                    type="text"
                    :placeholder="$t('appearances.create.name_placeholder')"
                />
            </div> -->

            <div class="flex">
                <AvatarUpload @file-uploaded="onFileUploaded" />
            </div>

            <ColorPicker
                v-model:primary="primaryColor"
                v-model:gray="grayColor"
            />

            <ThemeSwitch v-model="darkMode" />
            <BorderRadius v-model="borderRadius" />
        </div>
    </div>
</template>

<script setup lang="ts">
import ColorPicker from "@/Pages/ZapTime/App/Appearances/components/ColorPicker/index.vue";
import ThemeSwitch from "../../Appearances/components/ThemeSwitch.vue";
import AvatarUpload from "@/components/ui/avatar-upload/AvatarUpload.vue";
import {
    BorderRadius,
    type Radius,
} from "../../Appearances/components/BorderRadius";
import { IAppearance } from "@/types/IAppearance";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { watchThrottled } from "@vueuse/core";

const props = defineProps<{
    appearance: IAppearance;
}>();

const primaryColor = ref(props.appearance.data.primaryColor);
const grayColor = ref(props.appearance.data.grayColor);
const darkMode = ref(props.appearance.data.darkMode);
const borderRadius = ref<Radius>(props.appearance.data.borderRadius);

watchThrottled([primaryColor, grayColor, darkMode, borderRadius], saveChanges, {
    throttle: 500,
});

function onFileUploaded(file: File) {
    console.log(file);
}

async function saveChanges() {
    try {
        await router.put(
            route("app.appearances.update", {
                appearance: props.appearance.id,
            }),
            {
                name: props.appearance.name,
                data: {
                    primaryColor: primaryColor.value,
                    grayColor: grayColor.value,
                    borderRadius: borderRadius.value,
                    defaultSize: "mobile",
                    darkMode: darkMode.value,
                },
            },
            {
                preserveScroll: true,
            },
        );
    } catch (err) {
        console.log(err);
    }
}
</script>
